import React from "react";

const CampaignFilters = () => {

    return (

        <div className="campaign-filters">

            <input
                type="text"
                placeholder="Search Campaign..."
            />

            <select>

                <option>All Types</option>

                <option>Festival</option>

                <option>Referral</option>

                <option>Coupon</option>

                <option>Cashback</option>

                <option>Banner</option>

                <option>Email</option>

                <option>SMS</option>

                <option>Push</option>

            </select>

            <select>

                <option>All Status</option>

                <option>Draft</option>

                <option>Scheduled</option>

                <option>Running</option>

                <option>Paused</option>

                <option>Completed</option>

            </select>

            <input type="date" />

            <input type="date" />

            <button>

                Filter

            </button>

        </div>

    );

};

export default CampaignFilters;